import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import styles from './style.module.scss'
import { useState, useRef, useEffect } from 'react'
import MenuElevationShowColumns from '../MenuElevationShowColumns'
import MenuItemChecked from '../MenuElevationShowColumns/menuItemChecked';
import { BtnModalOrder, BtnSaveMenu } from '../Ui/Btn';
import { toast } from 'react-toastify';
import { api } from '../../../services/api';
import ButtonEdit from '../buttonEdit';
import ChipSys from '../chipSys';
import IconButtonUsers from '../usersIcon';
import SwitchUser from './switchUser';
import LogoIconButton from '../logoIconButton';
import { Typography } from '@mui/material';

const colorGreen = <Typography color='green'> Sucesso</Typography>
const colorRed = <Typography color='red'> Erro</Typography>

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) {
			return order;
		}
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
	const { order, orderBy, onRequestSort, header: headerAlias, handleHide, handleClick } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	const [header, setHeader] = useState(headerAlias)

	useEffect(() => {
		setHeader(headerAlias)
	}, [headerAlias])

	const handleCenter = (headCell) => {
		if (headCell == "Status") {
			return true
		}
		if (headCell == "Alterar Status") {
			return true
		}
		return false
	}

	const handlePadding = (headCell) => {
		if (headCell == "Status") {
			return "24px"
		}
		if (headCell == "Editar") {
			return "15px"
		}

		return "none"
	}


	return (
		<TableHead>
			<TableRow>
				{header.map((headCell) => {
					if (headCell?.visible === false) return (null)
					else return (
						<TableCell
							key={headCell.id}
							align={headCell.numeric ? 'right' : 'left'}
							padding={'none'}
							sortDirection={orderBy === headCell.id ? order : false}
						>
							<div style={{ display: 'flex', justifyContent: handleCenter(headCell.label) ? 'center' : 'flex-start', paddingLeft: handlePadding(headCell.label) }}>
								{/* <MenuElevationTable>
									<MenuItemTable onClick={() => handleHide(headCell, true)}>
										Hide
									</MenuItemTable>
									<MenuItemTable
										onClick={handleClick}
									>
										Show and sort columns
									</MenuItemTable>
								</MenuElevationTable> */}
								<TableSortLabel
									active={orderBy === headCell.id}
									direction={orderBy === headCell.id ? order : 'asc'}
									onClick={createSortHandler(headCell.id)}
								>
									{headCell.label}
									{orderBy === headCell.id ? (
										<Box component="span" sx={visuallyHidden}>
											{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
										</Box>
									) : null}
								</TableSortLabel>
							</div>
						</TableCell>
					)
				})}
			</TableRow>
		</TableHead >
	);
}

export default function TableSys({ handleEdit, handleView, header, dados: dadosPai, permissionVisualizar, permissionEditar, pageId: idPage, element, listType, moduleConfig, handleUsers, handleStatus, handleLogo, ...props }) {
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('item2');
	const [selected, setSelected] = React.useState([]);
	const [page, setPage] = React.useState(0);
	const [dense, setDense] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	const [headerState, setHeaderState] = useState([])

	const [confiInitTable, setInitConfiTable] = useState([]);
	const [confiTable, setConfiTable] = useState([]);
	const [pageId, setPageId] = useState('')
	const [loadingPage, setLoadingPage] = useState(false);
	const [idConfig, setIdConfig] = useState('');
	const [saveInHide, setSaveInHide] = useState(null)
	const [loading, setLoading] = useState(true);
	const [dados, setDados] = useState([])
	const [configModule, setConfigModule] = useState(false)

	useEffect(() => {
		setDados(dadosPai)
		setLoading(false)
	}, [dadosPai])

	useEffect(() => {
		setConfigModule(moduleConfig)
	}, [moduleConfig])

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelected = dados.map((n) => n.name);
			setSelected(newSelected);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const isSelected = (name) => selected.indexOf(name) !== -1;

	const handleHide = (item, save = null) => {
		const listHide = headerState.length - headerState.filter(el => el.visible === false).length
		if (listHide === 1) {
			toast.error("Não é possível esconder todas colunas")
			return
		}

		setHeaderState(arr => {
			arr.map(obj => {
				if (obj.id === item.id && arr.length) {
					obj.visible = false
				}
			})
			return [...arr]
		})

		if (save !== null) setSaveInHide(!!!saveInHide)
	}

	const handleShow = (item) => {
		setHeaderState(arr => {
			arr.map(obj => {
				if (obj.id === item.id) {
					obj.visible = true
				}
			})
			return [...arr]
		})
	}

	useEffect(() => {
		if (idPage) setPageId(idPage)
	}, [idPage])

	useEffect(() => {
		if (pageId) getConfigTable(idPage)
	}, [pageId])

	useEffect(() => {
		setConfiTable(headerState)
	}, [headerState])

	useEffect(() => {
		if (!!confiInitTable.length) setHeaderState(confiInitTable)
		else setHeaderState(header)
	}, [confiInitTable])

	async function getConfigTable() {
		const rota = configModule ? "config/" : ""
		const config = await api({ method: "get", url: `/api/configtables/${rota}${pageId}` });
		if (config.data) {
			setInitConfiTable(JSON.parse(config.data?.config_table));
			setConfiTable(JSON.parse(config.data?.config_table));
			setIdConfig(config.data.id)
		} else {
			setHeaderState(header)
		}
	}

	async function handleTableSalve() {
		const data = {
			configTable: JSON.stringify(confiTable),
			moduleId: pageId,
			moduleIdConfig: configModule
		}
		setLoadingPage(true)
		try {
			const config = await api({ method: "post", url: `/api/configtables`, data });
			setIdConfig(config.data.id)
			toast.success("Configurações salvas!")
		} catch (err) {

		}
		setLoadingPage(false)
	}

	async function handleTableUpdate() {
		const data = {
			configTable: JSON.stringify(confiTable),
			moduleIdConfig: configModule
		}
		setLoadingPage(true)
		try {
			const config = await api({ method: "put", url: `/api/configtables/config/${pageId}`, data });
			toast.success("Configurações salvas!")
		} catch (err) {

		}
		setLoadingPage(false)
	}

	const [anchorEl, setAnchorEl] = useState(null);
	const openMenu = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(boxRef.current);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const boxRef = useRef(null)

	function handleValue(e, newValue) {
		let value = +e.order
		newValue = +newValue
		if (newValue <= headerState.length && newValue > 0) {
			var listaView = headerState
			var prevew2 = null
			var newElem2 = null
			listaView.map((elemento, i) => {
				if (i + 1 == newValue && elemento.id != e.id) {
					elemento.order = +value
					prevew2 = elemento
				}
				if (elemento.id == e.id) {
					elemento.order = +newValue
					newElem2 = elemento
				}
			})
			listaView[value - 1] = prevew2
			listaView[newValue - 1] = newElem2
			setHeaderState([...listaView])
		}
	}

	useEffect(() => {
		if (saveInHide !== null) {
			if (!!idConfig) handleTableUpdate()
			else handleTableSalve()
		}
	}, [saveInHide])

	return (
		<>
			<Box sx={{ width: '100%' }}
				{...props}
				id='show-columns'
				aria-controls={openMenu ? 'show-columns' : undefined}
				aria-haspopup="true"
				aria-expanded={openMenu ? 'true' : undefined}
				ref={boxRef}
			>
				{
					loading && (
						<div className="d-flex justify-content-center">
						</div>
					)
				}
				<TableContainer>
					<Table
						className=''
						sx={{ minWidth: 750 }}
						aria-labelledby="tableTitle"
						size={dense ? 'small' : 'medium'}
					>
						<EnhancedTableHead
							numSelected={selected?.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={dados?.length}
							header={headerState}
							handleHide={handleHide}
							handleShow={handleShow}
							handleClick={handleClick}
						/>

						<TableBody>
							{dados?.length > 0 ? stableSort(dados, getComparator(order, orderBy))
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row, index) => {
									const isItemSelected = isSelected(row.name);
									const labelId = `enhanced-table-checkbox-${index}`;
									return (
										<TableRow
										    sx={{height: "38px"}}
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											{headerState.map((el, index) => {
												if (el?.visible === false) return (null)
												else switch (el.id) {
													case 'action_view':
														return (
															<TableCell
																style={{ padding: element ? '8px' : '', }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																{permissionVisualizar &&
																	<div className={styles.areaBtnTable}>
																	</div>
																}
															</TableCell>
														)
													case 'action_edit':
														return (
															<TableCell
																sx={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																{/* {permissionEditar &&
																} */}
																<ButtonEdit onClick={() => handleEdit(row)}></ButtonEdit>
															</TableCell>
														)
													case 'action_both':
														return (
															<TableCell
																style={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																<div className={styles.areaBtnTable}>
																	{/* {permissionVisualizar &&
																	}
																	{permissionEditar &&
																	} */}
																</div>
															</TableCell>
														)
													case 'action_both_administrar':
														return (
															<TableCell
																style={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																<div className={styles.areaBtnTable}>
																	{/* {permissionVisualizar &&

																	}
																	{permissionEditar && (
																		<>
																			{listType == 1 ?

																			}
																		</>
																	)} */}
																</div>
															</TableCell>
														)
													case 'status_obter_ajuda':
														return (
															<TableCell
																style={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																{/* {
																	row.status == 1 &&
																	(
																	)
																} */}
															</TableCell>
														)
													case 'status':
														return (
															<TableCell
																sx={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																<div style={{display: "flex", width: "100%", justifyContent: "center"}}>
																	<SwitchUser value={!!row[el.id]} row={row} handleStatusParent={() => handleStatus()}></SwitchUser>
																</div>
															</TableCell>
														)
														
													case 'logos':
														return (
															<TableCell
																style={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																<LogoIconButton logo={!!row[el.id]} onClick={() => handleLogo(row)}></LogoIconButton>
															</TableCell>
														)
													case 'count_users':
														return (
															<TableCell
																sx={{ padding: element ? '8px' : '', display: "flex", alignItems: "center" }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																{row[el.id]}
																<IconButtonUsers onClick={() => handleUsers(row)}>
																</IconButtonUsers>
															</TableCell>
														)
													case 'cre_ativo':
														return (
															<TableCell
																sx={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
																	<ChipSys label={!row[el.id] ? "Inativo" : "Ativo"} color={!row[el.id] ? "blueSys" : "success"}>
																	</ChipSys>

																</div>
															</TableCell>
														)
														case 'typeSync':
															return (
																<TableCell
																	sx={{ padding: element ? '8px' : '' }}
																	component="th"
																	id={labelId}
																	scope="row"
																	
																	padding="none"
																	key={index}
																>
																	{ row?.user == 'Sistema' ? 'Automático' : 'Manual'}
																</TableCell>
															)
															case 'statusLog':
															return (
																<TableCell
																	sx={{ padding: element ? '8px' : '' }}
																	component="th"
																	id={labelId}
																	scope="row"
																	padding="none"
																	key={index}
																>
																	<div style={{display: "flex", width: "100%", justifyContent: "center",marginLeft:"10px"}}>
																	{ row?.statusLog  == 'Sucesso' ? colorGreen :  colorRed}
																	</div>
																</TableCell>
															)
													default:
														return (
															<TableCell
																style={{ padding: element ? '8px' : '' }}
																component="th"
																id={labelId}
																scope="row"
																padding="none"
																key={index}
															>
																{row[el.id]}
															</TableCell>
														)
												}
											})}
										</TableRow>
									);
								}) : null}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					className={styles.select}
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					labelRowsPerPage="Linhas por página"
					count={dados?.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Box>
			<MenuElevationShowColumns
				id="show-columns" anchorEl={anchorEl} open={openMenu} onClose={handleClose}
			>
				{headerState.map((headCell, index) => (
					<div style={{ display: 'flex', padding: '8px', justifyContent: 'space-between', width: '100%' }} key={index}>
						<MenuItemChecked label={headCell.label} checked={headCell?.visible === false ? false : true}
							onChange={() => {
								if (headCell?.visible === false) handleShow(headCell)
								else handleHide(headCell)
							}} />
						<BtnModalOrder changeValue={handleValue} handleMinus={handleValue} handleAdd={handleValue} item={headCell} list={headerState} />

					</div>
				))}
				<BtnSaveMenu text={'Salvar'} onClick={!!idConfig ? handleTableUpdate : handleTableSalve}>
				</BtnSaveMenu>
			</MenuElevationShowColumns>
		</>

	);
}
